@if (auditResult) {
<div class="eeat-audit-container">
  <!-- Top Row: Composite Score and Horizontal Bars (Same Row) -->
  <div class="top-row">
    <!-- Composite Score Widget -->
    <app-composite-score-widget 
      [compositeScore]="compositeScore" 
      [title]="'EEAT Audit Score'" 
      [size]="'medium'">
    </app-composite-score-widget>

    <!-- Horizontal Bars Section -->
    @if (horizontalBarChartData && horizontalBarChartData.length > 0) {
      <div class="chart-section">
        <div class="chart-header">
          <div class="chart-title-section">
            <h4 class="chart-title">Dimension Scores</h4>
            <p class="chart-subtitle">Current performance across EEAT dimensions</p>
          </div>
        </div>
        <div class="chart-mobile-wrapper">
          <div class="horizontal-bar-wrapper">
            <app-bar-line-combo-chart
              [results]="horizontalBarChartData"
              [rightSided]="true"
              [xAxisLabel]="'Score (0-10)'"
              [yAxisLabel]="'Dimensions'"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [legend]="false"
              [animations]="true">
            </app-bar-line-combo-chart>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Radar Chart Section (Current vs Potential) -->
  @if (radarChartData && radarChartData.length > 0) {
    <div class="chart-section">
      <div class="chart-header">
        <div class="chart-title-section">
          <h4 class="chart-title">Current and Potential</h4>
          <p class="chart-subtitle">Comparison of current scores vs potential improvement</p>
        </div>
      </div>
      <div class="chart-mobile-wrapper">
        <div class="radar-chart-wrapper">
          <app-area-chart
            [areaChartData]="radarChartData"
            [scheme]="'vivid'"
            [animations]="true"
            [legend]="false"
            [xAxis]="true"
            [yAxis]="true"
            [showXAxisLabel]="false"
            [showYAxisLabel]="false"
            [xAxisLabel]="''"
            [yAxisLabel]="''"
            [maxValue]="10">
          </app-area-chart>
        </div>
      </div>
    </div>
  }

  <!-- Questions and Recommendations Table -->
  @if (questionsData.length > 0) {
    <div class="results-section">
      @let yourBrand = getYourBrandAuditResult();
      <div class="performance-table">
        <div class="table-header">
          <div class="table-title-section">
            <h3>Issues and Recommendations</h3>
            <p class="table-subtitle">
              Detailed assessment for 
              <span class="brand-name">{{ yourBrand?.brand || 'Brand' }}</span>
              @if (yourBrand?.category) { 
                <span class="category-badge">({{ yourBrand.category }})</span>
              }
            </p>
          </div>
        </div>
        <div class="table-container">
          <table class="audit-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Element</th>
                <th>Priority</th>
                <th>Problem and Recommendation</th>
              </tr>
            </thead>
            <tbody>
              @for (item of getFailedQuestions(); track item.question) {
                <tr>
                  <td>{{ item.dimension }}</td>
                  <td>{{ item.question }}</td>
                  <td>
                    <mat-icon class="priority-flag">flag</mat-icon>
                  </td>
                  <td class="recommendation-cell">
                    <div class="problem-text">
                      <strong>Problem:</strong> This criterion was not met.
                    </div>
                    @if (item.recommendation) {
                      <div class="recommendation-text">
                        <strong>Recommendation:</strong> {{ item.recommendation }}
                      </div>
                    } @else {
                      <div class="recommendation-text">
                        <strong>Recommendation:</strong> Review and improve {{ item.dimension }} based on this criterion.
                      </div>
                    }
                  </td>
                </tr>
              }
              @if (getFailedQuestions().length === 0) {
                <tr>
                  <td colspan="4" class="no-issues">
                    <mat-icon>check_circle</mat-icon>
                    <span>No issues found. All criteria are met!</span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  }

  <!-- HIDDEN: Evidence Sources / Data Sources & Citations (do not remove)
  @if (getEvidenceSources().length > 0) {
  <app-citation-card [citations]="getEvidenceSources()" [title]="'Evidence Sources (Tavily)'" [displayStyle]="'grid'"
    [maxDisplay]="6">
  </app-citation-card>
  }
  -->
</div>
} @else if (loading) {
  <div class="loading-container">
    <app-common-circle-loader message="Processing EEAT audit... This may take a few moments."></app-common-circle-loader>
  </div>
} @else {
  <div class="no-data-container">
    <div class="no-data-content">
      <mat-icon>analytics</mat-icon>
      <h3>No EEAT Audit Data Available</h3>
      <p>EEAT audit will be automatically triggered when you click the "Analysis" button in the filter section.</p>
    </div>
  </div>
}

@if (auditError) {
  <div class="error-container">
    <mat-icon>error</mat-icon>
    <p class="error-message">{{ auditError }}</p>
  </div>
}
